import { useEffect, useState } from "react"
import LockPage from "./Components/LockPage"
import InformationErrorModal from "../Components/Modals/InformationErrorModal"

const BYPASS_KEY = 'maintenance_bypass'
const BYPASS_PASSWORD = 'ferrodoadmin'

const MaintenanceGuard = ({ children }) => {
    const [appData, setAppData] = useState({ isLock: false, startDate: null, endDate: null })
    const [upcomingData, setUpcomingData] = useState({ show: false, startDate: null, endDate: null })
    const [isBypassed, setIsBypassed] = useState(() => localStorage.getItem(BYPASS_KEY) === BYPASS_PASSWORD)

    useEffect(() => {
        const checkStatus = () => {
            fetch(`/appData.json?t=${new Date().getTime()}`)
                .then(res => res.json())
                .then(data => {
                    const now = new Date()
                    const start = data.startAt ? new Date(data.startAt) : null
                    const end = data.endAt ? new Date(data.endAt) : null
                    const isValidDate = (d) => d instanceof Date && !isNaN(d)
                    if (data.isLock) {
                        setAppData({ isLock: true, startDate: null, endDate: null })
                        setUpcomingData(prev => ({ ...prev, show: false }))
                        return
                    }
                    if (isValidDate(start) && isValidDate(end)) {
                        // Sprawdzamy czy jesteśmy W TRAKCIE przerwy
                        if (now >= start && now <= end) {
                            setAppData({ isLock: true, startDate: start, endDate: end })
                            setUpcomingData(prev => ({ ...prev, show: false }))
                        }
                        // Nadchodzaca przerwa
                        else if (now < start) {
                            setAppData({ isLock: false, startDate: null, endDate: null })
                            const lastSeenDate = sessionStorage.getItem('maintenance_notice_seen')
                            // Porównujemy datę ze schowka z datą z JSONa. Jeśli są różne (bo to nowa przerwa lub user jeszcze nie widział), pokazujemy modal.
                            if (lastSeenDate !== start.toISOString()) {
                                setUpcomingData({ show: true, startDate: start, endDate: end })
                            } else {
                                // Jeśli user już to widział, upewniamy się, że modal jest ukryty
                                setUpcomingData(prev => ({ ...prev, show: false, startDate: start, endDate: end }))
                            }
                        }
                        // Po przerwie
                        else {
                            setAppData({ isLock: false, startDate: null, endDate: null })
                            setUpcomingData(prev => ({ ...prev, show: false }))
                        }
                    } else {
                        // Brak poprawnych dat i brak flagi isLock
                        setAppData({ isLock: false, startDate: null, endDate: null })
                    }
                })
                .catch((e) => {
                    console.error("Błąd checkStatus:", e)
                    setAppData({ isLock: false, startDate: null, endDate: null })
                })
        }

        checkStatus()
        const intervalId = setInterval(checkStatus, 5 * 60 * 1000)

        return () => clearInterval(intervalId)

    }, [])

    const formatDate = (date) => {
        if (!date) {
            return ''
        }
        const d = new Date(date)
        return new Intl.DateTimeFormat('pl-PL', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }).format(d)
    }

    const handleCloseModal = () => {
        setUpcomingData(prev => ({ ...prev, show: false }))
        if (upcomingData.startDate) {
            sessionStorage.setItem('maintenance_notice_seen', upcomingData.startDate.toISOString())
        }
    }

    const handleBypass = () => {
        localStorage.setItem(BYPASS_KEY, BYPASS_PASSWORD)
        setIsBypassed(true)
    }

    if (appData && appData.isLock && !isBypassed) {
        return <LockPage
            startDate={appData.startDate}
            endDate={appData.endDate}
            formatDate={formatDate}
            onBypass={handleBypass}
        />
    }
    else {
        return (<>
            <InformationErrorModal
                show={upcomingData.show}
                setShow={handleCloseModal}
                title={'Uwaga zaplanowane prace serwisowe!'}
                message={<>
                    <span>{`Zaplanowaliśmy prace serwisowe między`}</span>
                    <b className="ms-1">{`${formatDate(upcomingData.startDate)}`}</b>
                    <b>{` a ${formatDate(upcomingData.endDate)}`}</b>
                    <br />
                    <span>W tym czasie witryna będzie niedostępna!</span>
                    <br />
                    <span>Za utrudnienia przepraszamy.</span>
                </>}
                isError={false}
                buttonText="Rozumiem"
                showCloseButton={false}
            />
            {children}
        </>)
    }
}

export default MaintenanceGuard